import RequestQuestions from './RequestQuestions.component';

export default RequestQuestions;